import * as therapeuticCategoryActionTypes from './therapeuticCategoryActionTypes';

export const setCategoryList = (categoryList) => ({
  type: therapeuticCategoryActionTypes.SET_CATEGORY_LIST,
  categoryList,
});

export const addCategory = (category) => ({
  type: therapeuticCategoryActionTypes.ADD_CATEGORY,
  category,
});

export const updateCategory = (category) => ({
  type: therapeuticCategoryActionTypes.UPDATE_CATEGORY,
  category,
});

export const deleteCategory = (categoryId) => ({
  type: therapeuticCategoryActionTypes.DELETE_CATEGORY,
  categoryId,
});



// WEBPACK FOOTER //
// ./src/therapeuticCategory/therapeuticCategoryActions.js